
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background section-padding">
      <div className="glass rounded-xl p-10 max-w-md mx-auto text-center">
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-secondary flex items-center justify-center">
            <AlertTriangle className="h-10 w-10 text-primary" />
          </div>
        </div>
        
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-muted-foreground mb-6">
          Oops! This page doesn't exist.
        </p>
        
        <Button asChild>
          <Link to="/">Return to Dashboard</Link>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
